
        import ProductDataProvider from "./ProductDataProvider.js";

        window.addEventListener("load", function(){
          var provider = new ProductDataProvider();
          var product_sheet_url = document.getElementById("product_sheet_url").innerText;
          provider.insert(product_sheet_url);
        });
      